import React from 'react';
import { toast } from 'react-toastify';
import { DynamicField, DynamicFieldTypes, FileType } from 'src/components/dynamic-widget';
import DynamicFormWidget from 'src/components/dynamic-widget/DynamicFormWidget';
import GenericDrawer from 'src/components/drawer/GenericDrawer';
import { DataService } from 'src/services/data-service';

interface IAddImageProps {
  onSuccess: () => void;
  onClose: () => void;
}

const AddImage: React.FC<IAddImageProps> = ({ onClose, onSuccess }) => {
  const formConfig: Record<string, DynamicFieldTypes> = {
    name: {
      type: DynamicField.TEXT,
      required: true,
      name: 'name',
      title: 'Name',
      value: '',
      disabled: false,
    },
    file: {
      type: DynamicField.FILE,
      required: true,
      name: 'file',
      title: 'Image File',
      value: '',
      disabled: false,
      maxSizeInMbs: 5,
      allowedTypes: [FileType.JPG, FileType.JPEG, FileType.PNG, FileType.GIF],
    },
  };

  const submit = async (data) => {
    const dateUploaded = new Date().toISOString().split('T')[0]; // Current date in YYYY-MM-DD format
    let data2 ={
        Code: new Date().toISOString(),
        Name: data.name,
    }

     const formData = new FormData();
        const file: File = data.file;
        formData.append('request', JSON.stringify(data2));
        formData.append('formFile', file, file.name);
        const req = await DataService.postForm('api/media/create', formData);

        if (req.ok) {
            await onSuccess();
            return true;
          } else {
            toast.error('An Error occured!');
          }
          return false;
    
  };

  return (
    <GenericDrawer title="Add Image" open={true} onClose={onClose}>
      <DynamicFormWidget
        drawerMode
        title=""
        fields={formConfig}
        onSubmit={async (formData) => {
          return await submit(formData);
        }}
      />
    </GenericDrawer>
  );
};

export default AddImage;
